var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.enable,"max-width":"290"},on:{"input":_vm.close}},[_c('v-card',[_c('div',{staticClass:"pa-3"},[_vm._v(" Stiskněte ctrl+v pro vložení obrázku ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }